import { PHONE_NUMBER_ITALY } from './regex'

export const isValidItalianPhoneNumber = (phone: string) => PHONE_NUMBER_ITALY.test(phone)
